import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ControlsOf, FormControl, FormGroup } from '@ngneat/reactive-forms';
import { Hiring } from 'src/app/classes/hiring';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog-service/confirm-dialog.service';
import { EntitiesService } from 'src/app/services/entities/entities.service';
import { EntityType } from 'src/app/services/entities/entity-type.class';
import { HiringService } from 'src/app/services/hiring.service';

@Component({
    selector: 'app-hiring-company-edit-dialog',
    templateUrl: './hiring-company-edit-dialog.component.html',
    styleUrls: ['./hiring-company-edit-dialog.component.scss'],
    standalone: false,
})
export class HiringCompanyEditDialogComponent implements OnInit {
    title: string;
    saving = false;
    submitted = false;
    entityTypes: EntityType[];

    form: FormGroup<
        ControlsOf<{
            name: string;
            phone: string;
            email: string;
            entityTypes: any;
        }>
    >;

    constructor(
        @Inject(MAT_DIALOG_DATA) public hiring: Hiring,
        private confirmDialog: ConfirmDialogService,
        public dialogRef: MatDialogRef<HiringCompanyEditDialogComponent>,
        private hiringService: HiringService,
        private entitiesService: EntitiesService
    ) {}

    ngOnInit(): void {
        if (this.hiring) {
            this.createForm(this.hiring);
        }
        this.entitiesService.getTypes().subscribe(types => {
            this.entityTypes = types.data.filter(type => !type.is_team);
        });
    }

    createForm(hiring: Hiring) {
        this.form = new FormGroup({
            name: new FormControl(hiring.name),
            phone: new FormControl(hiring.phone),
            email: new FormControl(hiring.email),
            entityTypes: new FormControl(hiring.entitytypes.map(e => e.key)),
        });

        this.form.controls.name.disable();
        this.form.controls.phone.disable();
        this.form.controls.email.disable();
    }

    save() {
        this.submitted = true;
        this.saving = true;
        if (this.form.valid) {
            Object.assign(this.hiring, this.form.value);
            this.hiringService.save(this.hiring).then(
                hiring => {
                    this.saving = false;
                    this.close();
                },
                error => {
                    this.saving = false;
                    this.confirmDialog.confirm({
                        title: 'Fout tijdens het opslaan',
                        text: 'Er is iets fout gegaan tijdens het opslaan',
                        confirm: 'Oké',
                        cancel: null,
                    });
                }
            );
        } else {
            for (const name of Object.keys(this.form.controls)) {
                this.form.controls[name].markAsTouched();
            }
            this.saving = false;
        }
    }

    close() {
        this.dialogRef.close();
    }
}
